/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Frame_Rate_HelpInputs */



/**
* | output |
* | --- |
* | "Target frame rate" |
*
* @param {Embed_Captions_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_frame_rate_help = /** @type {((inputs?: Embed_Captions_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Frequence d'images cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielbildrate")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza dei fotogrammi di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевая частота кадров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de fotogramas objetivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标帧率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("目標フレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फ्रेम दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros alvo")
	return /** @type {LocalizedString} */ ("Target frame rate")
});